import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiWayleaveConstants } from "../../constants/api-constants/api-wayleave.constants";
let WayleaveService = class WayleaveService {
    http;
    constructor(http) {
        this.http = http;
    }
    getSetProfessionalBodiesObservable(applicationId, params) {
        return this.http.post(`${ApiWayleaveConstants.URL}/${applicationId}/${ApiWayleaveConstants.FUNCTION_SET_PROFESSIONAL_BODIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getSetLocationObservable(applicationId, params) {
        return this.http.post(`${ApiWayleaveConstants.URL}/${applicationId}/${ApiWayleaveConstants.FUNCTION_SET_LOCATION}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return this.http.post(`${ApiWayleaveConstants.URL}/${ApiWayleaveConstants.FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
WayleaveService = __decorate([
    Injectable({
        providedIn: "root"
    })
], WayleaveService);
export { WayleaveService };
